// src/services/configuracionesService.js
import api from "./Api"; // 👈 coincide con el nombre real del archivo

// Siempre con "/" inicial para que se una bien con baseURL de Api.js
const PATH = "/Configuraciones/valores-referencia";

// Listar (con opción de incluir inactivos)
const listarValoresReferencia = async (incluirInactivos = true, generales = false) => {
  const { data } = await api.get(`${PATH}/listar`, { params: { incluirInactivos, generales } });
  return Array.isArray(data) ? data : [];
};

// Crear
const crearValorReferencia = async (payload, generales = false) => {
  const { data } = await api.post(`${PATH}/crear`, payload, {params: {generales}});
  return data;
};

// Actualizar
const actualizarValorReferencia = (id, payload, generales = false) =>
  api.put(`${PATH}/actualizar/${id}`, payload, {params: {generales}});

// Desactivar
const desactivarValorReferencia = async (id, generales = false) => {
  const { data } = await api.put(`${PATH}/desactivar/${id}`, {}, {params: {generales}});
  return data;
};

// Reactivar
const reactivarValorReferencia = async (id, generales = false) => {
  const { data } = await api.put(`${PATH}/reactivar/${id}`, {}, {params: {generales}});
  return data;
};

// Eliminar permanente (hard delete)
const eliminarValorReferenciaHard = async (id, generales = false) => {
  const { data } = await api.delete(`${PATH}/eliminar-permanente/${id}`);
  return data;
};

const configuracionesService = {
  listarValoresReferencia,
  crearValorReferencia,
  actualizarValorReferencia,
  desactivarValorReferencia,
  reactivarValorReferencia,
  eliminarValorReferenciaHard,
};

export default configuracionesService;
export {
  listarValoresReferencia,
  crearValorReferencia,
  actualizarValorReferencia,
  desactivarValorReferencia,
  reactivarValorReferencia,
  eliminarValorReferenciaHard,
};
